import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { Spin, Row, Col, Button, Select, Tooltip, Modal, Checkbox, message } from 'antd';
import { find } from 'lodash';

import {
    loadManagerReports,
    setSelectedYear,
} from '../actions';
import * as constants from '../constants';

import uistate from '../../uistate';
import common from '../../../common';
import core from '../../core';
import currentuser from '../../currentuser';
import globalappstate from '../../globalappstate';
import companies from '../../companies';

const { AgGridWithState } = core;
const { currentUserHasRights, RendererBoolean, RendererStatus } = common;

class ReportsGrid extends Component {

    state = {
        selectedIdReport: 0,
        currentEditEntity: {},
        editFormVisible: false,
    }

    constructor(props) {
        super(props);
    }

    UNSAFE_componentWillMount() {
        this.props.loadManagerReports(this.props.selectedYear);
    }
    componentWillUnmount() {
        if (this.gridApi) {
            var columnState = this.gridApi.getColumnState()
            var filterModel = this.gridApi.getFilterModel()
            this.props.saveGridFilters('ReportsGrid', { columnState, filterModel })
        }
    }

    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'ReportsGrid', key);
    }
    nrFormatter = (params) => {
        if (params.value) {
            return Number(params.value).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        } else {
            return ''
        }
    }
    refreshClicked = () => {
        this.props.loadManagerReports(this.props.selectedYear);
    }

    getGridCols = () => {
        let cols = [
            { key: "status", headerName: this.label("Status"), field: "status", sortable: true, filter: false, enableRowGroup: true, suppressHeaderMenuButton: true, width: 80, minWidth: 80, maxWidth: 80, cellRenderer: 'rendererStatus' },
            { key: "number", width: 110, minWidth: 110, maxWidth: 110, headerName: this.label("Number"), field: "number", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true, filter: "agTextColumnFilter" },
            { key: "type", width: 70, headerName: this.label("Type"), field: "type", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true },
            { key: "personnelNumber", headerName: this.label("PersonnelNumber"), field: "personnelNumber", sortable: true, filter: false, enableRowGroup: false, suppressHeaderMenuButton: true, width: 100, minWidth: 100, maxWidth: 100, filter: "agTextColumnFilter" },
            { key: "fullname", width: 70, headerName: this.label("Username"), field: "fullname", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true, filter: "agTextColumnFilter", rowGroup: true },
            { key: "department", width: 70, headerName: this.label("Department"), field: "department", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true, filter: "agTextColumnFilter" },
            { key: "supervisor", width: 70, headerName: this.label("Supervisor"), field: "supervisor", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true, filter: "agTextColumnFilter" },
            { key: "amount", width: 100, minWidth: 100, maxWidth: 100, headerName: this.label("Amount"), field: "amount", sortable: true, filter: false, enableRowGroup: false, suppressHeaderMenuButton: true, filter: "agTextColumnFilter", type: 'rightAligned', type: 'rightAligned', valueFormatter: this.nrFormatter },
        ]

        return cols;
    }

    onGridReady = (params) => {
        this.gridApi = params.api;


        if (this.props.gridfilterstate) {
            this.gridApi.applyColumnState({ state: this.props.gridfilterstate.columnState, applyOrder: true });
            this.gridApi.setFilterModel(this.props.gridfilterstate.filterModel);
        }
    };
    deselectAll = () => {
        if (this.gridApi) {
            this.gridApi.deselectAll()
        }
    }

    //#region Grid/Button handlers

    handleChangeYear = (value) => {
        this.props.setSelectedYear(value);
        this.props.loadManagerReports(value);
    }
    
    onDoubleClick = async (dataitem) => {
        this.props.history.push(`/app/reports/${dataitem.idReport}`)
    }
    onSelect = async (dataitem) => {
        this.setState({
            selectedIdReport: dataitem.idReport,
        });
    }

    //#endregion

    render() {
        const loading = this.props.loadingReports;
        const menuHeight = 45
        const gridHeight = this.props.contentHeight - menuHeight;
        const columnDefinitions = this.getGridCols();

        return (
            <div className='disputes'>
                <Row className='main-toolbar' style={{ height: menuHeight }} justify='start' align='middle' gutter={8}>
                    <Col span={24} >
                        <span className='module-title'>{this.label("Reports")}</span>
                        <span style={{ margin: 5, marginLeft: 25 }}>{this.label("Year")}</span>
                        <Select onChange={this.handleChangeYear} value={this.props.selectedYear}>
                            {
                                this.props.picklists.years ? this.props.picklists.years.map(o => <Select.Option key={o.id} value={o.id}>{o.name}</Select.Option>) : null
                            }
                        </Select>
                    </Col>
                </Row>
                {loading ? (
                    <div className="loader-content" >
                        <Spin size="large" />
                        <p>{this.label("Loading")}</p>
                    </div>
                ) : (
                    <>
                        <AgGridWithState height={gridHeight} ShowGroupPanel={true}
                            lang={this.props.curLanguage}
                            onReady={this.onGridReady}
                            onItemSelected={this.onSelect}
                            onItemDoubleClicked={this.onDoubleClick}
                            columnDefinitions={columnDefinitions}
                            data={this.props.reports}
                            onRefresh={this.refreshClicked}
                            labels={this.props.labels}
                            frameworkComponents={{
                                'rendererBoolean': RendererBoolean, 'rendererStatus': RendererStatus
                            }}
                        >
                        </AgGridWithState>
                    </>
                )}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        loadingReports: state[constants.NAME].loadingReports,
        reports: state[constants.NAME].reports,
        selectedYear: state[constants.NAME].selectedYear,
        contentHeight: state[uistate.constants.NAME].contentheight,
        labels: uistate.selectors.uiLabels(state),
        curLanguage: uistate.selectors.curLanguage(state),
        currentuser: state[currentuser.constants.NAME],
        picklists: globalappstate.selectors.allPicklists(state),
        gridfilterstate: state[uistate.constants.NAME].gridfilterstate['ReportsGrid'],
    };
}

export default connect(mapStateToProps,
    {
        loadManagerReports,
        setSelectedYear,
        saveGridFilters: uistate.actions.saveGridFilters
    })(ReportsGrid);